import React from 'react';
import styled, { css } from 'styled-components';

import { useTranslation } from '@lt/localization';
import HotelMapPopup from './HotelMapPopup';

const HotelRoulettePopup = ({ isMobile, onClose, location, assets }) => {
  const { t } = useTranslation();
  return (
    <StyledHotelMapPopup
      isMobile={isMobile}
      onClose={onClose}
      title={`${t('map.roulette.title')}\n${location}`}
      image={
        <StyledImage
          url={assets['hotels/fortuna-mobile.jpg']}
          url2x={assets['hotels/fortuna-mobile@2x.jpg']}
          url3x={assets['hotels/fortuna-mobile@3x.jpg']}
          isMobile={isMobile}
        />
      }
    />
  );
};

const StyledHotelMapPopup = styled(HotelMapPopup)`
  padding: ${({ isMobile }) => (isMobile ? '0 0 5px' : '0 0 25px')};
`;

const StyledImage = styled.div<{
  isMobile: boolean;
  url: string;
  url2x: string;
  url3x: string;
}>`
  ${({ isMobile }) => css`
    margin-bottom: ${isMobile ? '10px' : '30px'};
    width: ${isMobile ? '280px' : '378px'};
    height: ${isMobile ? '70px' : '103px'};
    background-size: ${isMobile ? 'cover' : 'contain'};
  `}

  ${({ url, url2x, url3x, isMobile }) => css`
    background-image: url(${url});

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
      background-image: url(${url2x});
    }

    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
      background-image: url(${url3x});
    }

    background-position: ${isMobile ? '0 0' : '100%'};
  `}
`;

export default HotelRoulettePopup;
